import React from 'react';
import { SectionTitle, SliderRow, StyleGrid } from './ui-primitives';
import { EyePreview, PupilPreview } from './canvas-previews';
const EYE_STYLES = [
    { id: 'square', label: 'Square' },
    { id: 'rounded', label: 'Rounded' },
    { id: 'circle', label: 'Circle' },
    { id: 'leaf', label: 'Leaf' },
    { id: 'diamond', label: 'Diamond' },
];
const PUPIL_STYLES = [
    { id: 'square', label: 'Square' },
    { id: 'rounded', label: 'Rounded' },
    { id: 'circle', label: 'Circle' },
    { id: 'halfleaf', label: 'Half Leaf' },
    { id: 'crystal', label: 'Crystal' },
    { id: 'shield', label: 'Shield' },
    { id: 'cross', label: 'Cross' },
    { id: 'star', label: 'Star' },
    { id: 'diamond', label: 'Diamond' },
    { id: 'pulse', label: 'Pulse' },
];
export function EyesPanel({ settings, update }) {
    return (<div className="space-y-4">
            <SectionTitle>Eye (Outer) Shape</SectionTitle>
            <StyleGrid items={EYE_STYLES} selected={settings.eyeStyle} onSelect={(id) => update('eyeStyle', id)} renderPreview={(id) => <EyePreview style={id} color={settings.eyeOut}/>}/>

            <SectionTitle>Pupil (Inner) Shape</SectionTitle>
            <StyleGrid items={PUPIL_STYLES} selected={settings.pupilStyle} onSelect={(id) => update('pupilStyle', id)} renderPreview={(id) => <PupilPreview style={id} color={settings.eyeIn}/>}/>

            <div className="space-y-3 pt-2">
                <SectionTitle>Pupil Transform</SectionTitle>
                <SliderRow label="Scale" value={settings.pupilScale} min={0.3} max={1.1} step={0.01} onChange={(v) => update('pupilScale', v)} display={settings.pupilScale.toFixed(2)}/>
                <SliderRow label="Rotation" value={settings.pupilRot} min={0} max={360} step={1} onChange={(v) => update('pupilRot', v)} display={`${settings.pupilRot}°`}/>
            </div>
        </div>);
}
